<template>
  <div class="edu-about-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="edu-about-image">
            <img src="../../assets/img/all-img/about5.png" alt="banner-img" style="border-radius: 12px;" />
          </div>
        </div>
        <div class="col-lg-5 col-md-12">
          <div class="edu-about-content">
            <p class="sub-title">Cvision</p>
            <h2>
              Her Şeyi, Her Zaman,
              <span class="shape02">Her Yerden</span>Öğrenebilirsin
            </h2>
            <div class="about-list">
              <div class="items">
                <div class="about-single-content">
                  <div class="icon">
                    <img src="../../assets/img/icon/video.svg" alt="icon" />
                  </div>
                  <div class="content">
                    <h3>Tüm Ders Videoları Sağlanır</h3>
                    <p>
                      Her dersin kayıtlı video versiyonuna erişim sağlayabilirsiniz. Böylece dersleri kaçırma derdiniz
                      olmaz, istediğiniz zaman tekrar izleyebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
              <div class="items">
                <div class="about-single-content">
                  <div class="icon">
                    <img src="../../assets/img/icon/web-white.svg" alt="icon" />
                  </div>
                  <div class="content">
                    <h3>Çevrimiçi Erişim Sağlanır</h3>
                    <p>
                      Eğitimlere internet bağlantısı olan her yerden katılabilirsiniz. İster bilgisayardan ister
                      telefondan giriş yaparak kolayca dersleri takip edebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>